import { Require } from '@sparelabs/core'
import { ZoneDirection, ZoneType } from '@sparelabs/domain-logic'
import { IPoint, Latitude, Longitude } from '@sparelabs/geography'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
// eslint-disable-next-line import/no-cycle
import { ServiceStatus, ServiceType } from './ServiceTypes'

export enum StopIcon {
  Home = 'home',
  Work = 'briefcase',
  Gym = 'dumbbell',
  School = 'graduation-cap',
  Star = 'star',
  Restaurant = 'utensils',
  Train = 'train',
  Heart = 'heart',
  Community = 'praying-hands',
}

export interface IStopPostBody {
  code: string
  name: string
  location: IPoint
  description?: string | null
  internalDescription?: string | null
  wheelchairBoarding?: boolean
  isVisibleToRiderApp?: boolean
  isTransitHub?: boolean
  isEnabled?: boolean
  icon?: StopIcon | null
  importance?: number
  imageUrl?: string | null

  /**
   * @deprecated to support a many to many relationship between zones and stops. To create a connection between a zone and a stop, please use ZoneStop operations
   */
  zoneId?: string
}

export type IStopPatchBody = Partial<IStopPostBody>
export interface IStopResponse
  extends IModelJsonValues,
    Require<
      IStopPostBody,
      | 'description'
      | 'internalDescription'
      | 'wheelchairBoarding'
      | 'isVisibleToRiderApp'
      | 'isTransitHub'
      | 'isEnabled'
      | 'importance'
      | 'icon'
      | 'imageUrl'
    > {
  zoneIds: string[]
}

export interface IStopListQueryParams extends IListModelQueryParamValues {
  search?: string
  serviceId?: string
  serviceIds?: string[]
  zoneId?: string
  zoneDirection?: ZoneDirection
  zoneType?: ZoneType[] | ZoneType
  serviceType?: ServiceType[]
  serviceStatus?: ServiceStatus[] | ServiceStatus
  timeRuleId?: string
  isVisibleToRiderApp?: boolean
  isZoneVisibleToRiderApp?: boolean
  hideGroupRestrictedStops?: boolean
  isEnabled?: boolean
  searchAreaLatitude?: Latitude
  searchAreaLatitudeDelta?: number
  searchAreaLongitude?: Longitude
  searchAreaLongitudeDelta?: number
  minImportance?: number
  maxImportance?: number
}
